import OddsCenter from "../../components/oddsCenter";

export default function OddsCenterPage() {
  return <OddsCenter />;
}
